import { generateId } from 'helpers/random';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import "./style.scss";

export default function HubspotForm({
  portalId, 
  formId, 
  defaultValues, 
  region="", 
  locale="",
}){
  const [ hbspt, set_hbspt ] = useState(null);
  const [ portal_id ] = useState(portalId);
  const [ form_id ] = useState(formId);
  const [ _region ] = useState(region);
  const [ _locale ] = useState(locale);
  const [ id ] = useState(generateId("form_hubspot"));

  const scriptLoaded = useCallback(()=>{
    set_hbspt(window.hbspt);
  },[]);

  const extractData = useCallback((form)=>{
    // var formData = new FormData(document.getElementById(`hsForm_${form_id}`))
    let fields = [
      ...form.getElementsByClassName("hs-input")
      // ...form.getElementsByTagName("input"),
      // ...form.getElementsByTagName("textarea"),
      // ...form.getElementsByTagName("select"),
    ];

    // fields.forEach(field=>{
    //   field.addEventListener("change",(e)=>{
    //     console.log(e);
    //   });
    // })
  },[]);

  const setDefaultValues = useCallback((form)=>{
    // var formData = new FormData(document.getElementById(`hsForm_${form_id}`))
    if(defaultValues){
      let fields = [
        ...form.getElementsByClassName("hs-input")
      ];
      Object.keys(defaultValues).forEach((name)=>{
        let aux_l = fields.filter(field=>field.name === name);
        if(aux_l.length>0){
          aux_l[0].value = defaultValues[name];
          aux_l[0].checked = true;
        }
      })
    }
  },[defaultValues]);

  // const removeLoad = useCallback(()=>{
  //   if(!!ref.current){
  //     let load = document.getElementById(`load_${id}`);
  //     ref.current.removeChild(load);
  //   }
  // },[ref, id])

  useEffect(()=>{
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js?pre=1";
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => scriptLoaded();
    document.body.appendChild(script);

    return ()=>{
      document.body.removeChild(script);
    }
  },[scriptLoaded]);

  useEffect(()=>{
    if(hbspt){
      if(!portal_id || !form_id){
        if(!portal_id) throw "missing portalId value";
        if(!form_id) throw "missing formId value";
      } else {
        hbspt.forms.create({
          region: _region,
          portalId: portal_id,
          formId: form_id,
          target:`#${id}`,
          locale: _locale,
          onBeforeFormInit:(e)=>{
            // console.log("onBeforeFormInit",e);
          },
          onReady:setDefaultValues
        });
      }
    }
  },[hbspt, portal_id, form_id, id, setDefaultValues, _region, _locale]);

  return (
    <div id={id}>
      <div className="load-form-hubspot">
        <Spinner animation="border"/>
      </div>
    </div>
  );
}